import { setConopsActivity_actionType } from "../constants";

export const setConopsActivity = (activity) => ({
  type: setConopsActivity_actionType,
  payload: activity,
});
